import { JSX } from 'react';
import { Checkbox, FormControlLabel, TableCell, TableRow, Tooltip } from '@mui/material';
import { Grid } from '@mui/system';
import { ExcelExportGet } from 'api';
import { shortDate } from 'utilities';
import { COMPLETED_VALUE, REPORT_STATUSES } from '../../../constants';

const ReportStatusRow = ({
  reportStatus,
  icon,
  handleIndividualChange,
  checkedForZipJob,
  handleEnqueueCheckboxChange,
  checkedForEnqueue,
  displayDateTooltip,
}: {
  reportStatus: ExcelExportGet;
  icon: JSX.Element;
  handleIndividualChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkedForZipJob: boolean;
  handleEnqueueCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkedForEnqueue: boolean;
  displayDateTooltip: boolean;
}) => (
  <TableRow>
    <TableCell sx={{ width: '40%' }}>
      <FormControlLabel
        disabled={reportStatus.status !== COMPLETED_VALUE}
        control={
          <Checkbox
            onChange={handleIndividualChange}
            checked={checkedForZipJob}
            indeterminate={reportStatus.status !== COMPLETED_VALUE}
            id={reportStatus.company_measurement_date.toString()}
          />
        }
        label={
          <Tooltip title={displayDateTooltip ? shortDate(reportStatus.date) : ''} placement="right-end">
            <span>{reportStatus.company_name}</span>
          </Tooltip>
        }
      />
    </TableCell>
    <TableCell sx={{ width: '40%' }}>
      <Grid container direction="row">
        <Grid>{icon}</Grid>
        <Grid sx={{ marginLeft: '1.25em', paddingTop: '0.3em' }}>{REPORT_STATUSES[reportStatus.status as number]}</Grid>
      </Grid>
    </TableCell>
    <TableCell sx={{ width: '20%' }}>
      <FormControlLabel
        disabled={reportStatus.status === COMPLETED_VALUE}
        control={
          <Checkbox
            onChange={handleEnqueueCheckboxChange}
            checked={checkedForEnqueue}
            indeterminate={reportStatus.status === COMPLETED_VALUE}
            id={reportStatus.company_measurement_date.toString()}
          />
        }
        label=""
      />
    </TableCell>
  </TableRow>
);

export default ReportStatusRow;
